export const Env = {
    appName: process.env.REACT_APP_APP_NAME || 'borrower-portal',
    isDev: process.env.NODE_ENV === 'development',
};
